import {NormalContentBlockModel} from "@/models/api/pharma-cms-content-block/NormalContentBlockModel";
import {ContactFormContentRestDto, ContentBlockMetadataRestDto,} from "@/api/pharma-cms-content-block/models";
import {StatusEnum} from "@/api/enums/status-enum";

export class ContactFormContentRestDtoModel extends NormalContentBlockModel implements ContactFormContentRestDto {
    cb_metadata?: ContentBlockMetadataRestDto;
    pharmacy_code?: string | null;
    sort_weight?: number;
    status_code: StatusEnum;
    email_settings: object | null;


    constructor(status_code: StatusEnum) {
        super();
        this.status_code = status_code;
        this.email_settings = null;
    }

    public static createWithDefaults(): ContactFormContentRestDtoModel {
        const model = new ContactFormContentRestDtoModel(StatusEnum.PUBLISHED);
        model.pharmacy_code = null;
        // model.sort_weight = NormalContentBlockModel.getDefaultSortWeight();

        return model;
    }

    public static cloneFrom(source: ContactFormContentRestDto): ContactFormContentRestDtoModel {
        const model = new this(source.status_code);
        model.cb_metadata = source.cb_metadata ?? undefined;
        model.email_settings = source.email_settings ?? null;
        model.pharmacy_code = source.pharmacy_code;
        model.sort_weight = source.sort_weight ?? undefined;

        return model;
    }
}
